export default __webpack_public_path__ + "static/media/IMG_4571-min.e724e6f5.JPG";